export class ListValidator {

    validateList(table: any, permission: any): boolean {
        return table.find((uuid : any) => {
            return uuid == permission;
        }) ? false : true;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/classes/listValidator.ts